import { getApiUrl } from "../config";
import { get, post } from "./axiosRequest";
import { ORG_ID } from "../constant/constant";

export const getLmsReport = async (data) => {
  const url = `${getApiUrl().reportApiUrl}/LmsReport/LmsReport`;

  try {
    return await post(url, data, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};

export const getLmsReportCourse = async (data) => {
  const url = `${getApiUrl().reportApiUrl}/LmsReport/GetCourse`;

  try {
    return await post(url, data, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};

export const getLmsReportLesson = async (data) => {
  const url = `${getApiUrl().reportApiUrl}/LmsReport/GetLesson`;

  try {
    return await post(url, data, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};

export const getLmsDashboardReport = async (data) => {
  const url = `${
    getApiUrl().reportApiUrl
  }/LmsReport/LMSDashboardReport?fromDate=${data.startDate}&toDate=${
    data.endDate
  }&divisionId=${data.divisionId}&allClient=${data?.allClient}&groupId=${data?.groupId ? data?.groupId : 0}`;

  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};

export const getLmsDashboardReportDetails = async (data) => {
  const url = `${
    getApiUrl().reportApiUrl
  }/LmsReport/LMSDashboardReportDetails?fromDate=${data.startDate}&toDate=${
    data.endDate
  }&divisionId=${data.divisionId}&reportDetails=${data.reportDetails}&page=${
    data.page
  }&pageSize=${data.pageSize}&trainingType=${
    data?.trainingType ? data?.trainingType : ""
  }&isSendMail=${data?.isSendMail}&groupId=${data?.groupId ? data?.groupId : 0}`;
  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};

export const getLmsDashboardCourseLessonSafetyMeetingCompleted = async (
  data,
) => {
  const url = `${
    getApiUrl().reportApiUrl
  }/LmsReport/LMSCourseLessonSafetyMeetingCompletedList?fromDate=${
    data.fromDate
  }&toDate=${data.toDate}&divisionId=${data.divisionId}&page=${
    data.pageNumber
  }&pageSize=${data.pageSize}&trainingType=${
    data?.trainingType ? data?.trainingType : []
  }&userId=${data?.userId}&statusId=${data?.statusId}&IsSendMail=${data?.IsSendMail}&groupId=${data?.groupId ? data?.groupId : 0}`;
  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};
export const getLmsDashboardCourseLessonSafetyMeetingInCompleted = async (
  data,
) => {
  const url = `${
    getApiUrl().reportApiUrl
  }/LmsReport/LMSCourseLessonSafetyMeetingInCompletedList?fromDate=${
    data.fromDate
  }&toDate=${data.toDate}&divisionId=${data.divisionId}&page=${
    data.pageNumber
  }&pageSize=${data.pageSize}&trainingType=${
    data?.trainingType ? data?.trainingType : []
  }&userId=${data?.userId}&statusId=${data?.statusId}&isSendEmail=${
    data?.isSendEmail
  }&groupId=${data?.groupId ? data?.groupId : 0}`;
  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};
// scorm course Lms report Service
export const getMarketplaceCourseReport = async (data) => {
  const url = `${
    getApiUrl().reportApiUrl
  }/LmsReport/MarketplaceCourseReport?fromDate=${data.startDate}&toDate=${
    data.endDate
  }&page=${data.page}&pageSize=${data.pageSize}&userName=${
    data?.search
  }&statusId=${data?.statusId}&DivisionId=${data?.DivisionId}&isSendMail=${
    data?.isSendMail
  }&allClient=${data?.allClient}&groupId=${data?.groupId ? data?.groupId : 0}`;
  try {
    return await get(url, {
      headers: {
        Authorization: localStorage.getItem("id_token"),
        orgId: data?.clients ? data?.clients?.key : ORG_ID(),
      },
    });
  } catch (error) {
    return error;
  }
};
